import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/usen_logo.svg'


const _hoisted_1 = { class: "top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"logo\" data-v-12e7bd0b><img src=\"" + _imports_0 + "\" data-v-12e7bd0b></div><ul class=\"top-right-item\" data-v-12e7bd0b><li class=\"help-style\" data-v-12e7bd0b><a href=\"https://support.usen.com/\" target=\"_blank\" data-v-12e7bd0b>ヘルプ・サポート</a></li><li data-v-12e7bd0b>お店の未来を創造する</li></ul>", 2)
  ])))
}